import React from 'react';
import { Grid, TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SelectField from '../inputs/SelectField';
import { PRICING_RULE_TYPES } from '../../constants/appConstants';

function PricingRuleFields({ label, rule, onChange, currencySymbol }) {
  const { t } = useTranslation();
  const type = rule?.type || PRICING_RULE_TYPES.NONE;
  const showValue = type !== PRICING_RULE_TYPES.NONE;

  const typeOptions = [
    { value: PRICING_RULE_TYPES.NONE, label: t('clients.pricing.types.none') },
    { value: PRICING_RULE_TYPES.FIXED_PER_CARAT, label: t('clients.pricing.types.fixed_per_carat') },
    { value: PRICING_RULE_TYPES.PERCENTAGE, label: t('clients.pricing.types.percentage') },
  ];

  return (
    <>
      <Grid item xs={12}>
        <SelectField
          label={label}
          value={type}
          onChange={(value) => onChange({ ...rule, type: value, value: rule?.value ?? 0 })}
          options={typeOptions}
          size="small"
        />
      </Grid>
      {showValue && (
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            label={t('clients.pricing.value')}
            type="number"
            value={rule?.value ?? ''}
            onChange={(e) => onChange({ ...rule, type, value: e.target.value })}
            inputProps={{ step: 'any' }}
            InputProps={{
              startAdornment: type === PRICING_RULE_TYPES.PERCENTAGE
                ? null
                : <InputAdornment position="start">{currencySymbol}</InputAdornment>,
              endAdornment: type === PRICING_RULE_TYPES.PERCENTAGE
                ? <InputAdornment position="end">%</InputAdornment>
                : null,
            }}
            helperText={type === PRICING_RULE_TYPES.PERCENTAGE
              ? t('clients.pricing.percentHelp')
              : t('clients.pricing.fixedHelp')}
          />
        </Grid>
      )}
    </>
  );
}

export default function ClientPricingFields({ pricingRules, onChange, currencySymbol = '$' }) {
  const { t } = useTranslation();

  const setRule = (key, next) => {
    onChange({
      ...pricingRules,
      [key]: next,
    });
  };

  return (
    <Grid container spacing={2}>
      <PricingRuleFields
        label={t('clients.pricing.certified')}
        rule={pricingRules?.certified}
        onChange={(next) => setRule('certified', next)}
        currencySymbol={currencySymbol}
      />
      <PricingRuleFields
        label={t('clients.pricing.lots')}
        rule={pricingRules?.lots}
        onChange={(next) => setRule('lots', next)}
        currencySymbol={currencySymbol}
      />
    </Grid>
  );
}
